import { render, staticRenderFns } from "./SelectKid.vue?vue&type=template&id=3f36e672&scoped=true&"
import script from "./SelectKid.vue?vue&type=script&lang=js&"
export * from "./SelectKid.vue?vue&type=script&lang=js&"
import style0 from "./SelectKid.vue?vue&type=style&index=0&id=3f36e672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36e672",
  null
  
)

export default component.exports